import { render, staticRenderFns } from "./OnneLogo.vue?vue&type=template&id=cc3a375e&"
import script from "./OnneLogo.vue?vue&type=script&lang=ts&"
export * from "./OnneLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports